import React, { useEffect, useState, useRef } from "react";
import { Paper } from "@material-ui/core";
import { useDataProvider } from "../../api/DataProvider";
import { useCommProvider } from "../../api/CommProvider";
import Avatar from '@material-ui/core/Avatar';
import { Tabs, Tab } from "@material-ui/core";
import { DialogInfoTeam } from "./DialogInfoTeam";
import { DialogInvitationSection } from "./DialogInvitationSection"
import { DialogTeamActivity } from "./DialogTeamActivity"
import { TaskTeams } from "./TaskTeams"
import { pTeamHomeTab } from "../../utils/parameters";
import UpdateIcon from '@mui/icons-material/Update';
import { Button, IconButton } from "@mui/material";
import ConfirmationDialog from '../utils/ConfirmationDialog';
import AvatarUploadImage from '../utils/AvatarUploadImage'; 
import { useTranslation } from "react-i18next";
import { DeviceQueries } from "../utils/DeviceQueries";
import { SignaPointsDialog } from "../dialog/SignaPointsDialog";


export function TeamHome(props) {
    const { team_id_selected, task_id_selected, setTask_id_selected, returnMenu } = props;
    const { t } = useTranslation("global")

    const [ infoTeam, setInfoTeam ] = useState({});
    const [ isAdmin, setIsAdmin ] = useState(false);
    
    const { comm_getInfoTeam, comm_updateTeam, comm_removeTeam } = useCommProvider();
    const { token_id, currentUser } = useDataProvider();
    const [ tabValue, setTabValue ] = useState(pTeamHomeTab.info);
    const [ isComfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [ openDialogSignaPoints, setOpenDialogSignaPoints ] = useState(false);
    const [ totalSignaPoints, setTotalSignaPoints ] = useState('?')


    /* MOB - Nav responsiveness */
    const queryMatches = DeviceQueries();

    useEffect(() => {
        async function getTeamsList() {
            // console.log('COM GET INFO TEAM')
            setInfoTeam(await comm_getInfoTeam(token_id, currentUser, team_id_selected))
        }
        getTeamsList();
        if (task_id_selected !==''){
            setTabValue(pTeamHomeTab.aula)
        }
    }, []);

    useEffect(() => {
        // console.log('infoTeam', infoTeam)
        if (infoTeam['arr_admin'] !== undefined){
            setIsAdmin(true)
        }
    }, [infoTeam]);

    async function update_InfoTeam(updated_data){
        await comm_updateTeam(token_id, currentUser, infoTeam['_id'], updated_data)
        setInfoTeam(await comm_getInfoTeam(token_id, currentUser, team_id_selected))
    }


    function update_ImageInfoTeam(imgBase64){
        const update_data = {
            'imgBase64':imgBase64
        }
        update_InfoTeam(update_data)
    }


    async function refresh_InfoTeam(){
        // console.log("🚀 ~ file: TeamHome.js:72 ~ refresh_InfoTeam ~ refresh_InfoTeam:", refresh_InfoTeam)
        setInfoTeam(await comm_getInfoTeam(token_id, currentUser, team_id_selected))
    }

    async function remove_Team(){
        // console.log("🚀 ~ file: TeamHome.js:77 ~ remove_Team ~ remove_Team:", remove_Team)
        setIsConfirmDialogOpen(false)
        await comm_removeTeam(token_id, currentUser, infoTeam['_id'])
        returnMenu()
    }
  

    return (
        <>
            <Button onClick={refresh_InfoTeam} className={`sig_Collab_Teams_ReturnButton sig_Collab_Terms_ReturnButton sig_Home_ChangeOnDarkMode ${(queryMatches.deviceLandscape || queryMatches.deviceLarge) ? 'sig_Teams_FixedButtonsCorrection' : ''}`} variant="contained">
                <UpdateIcon className="sig_Collab_UndoIcon" /> <span className="sig_Collab_Teams_ReturnButton_Label">{t("sTeams.refresh").toUpperCase()}</span>
            </Button>
            <Paper className='sig_Drawer_SettingsModal_Root sig_Teams_GroupMainSection'>
                <div className="sig_Account_Header">
                    <AvatarUploadImage image={infoTeam['imgBase64']} editable={isAdmin} handleSendImage={update_ImageInfoTeam}/>
                    <div className='sig_SignModal_PaperLine'>
                        <div className="sig_Account_Header_Name">{ infoTeam['_id'] }</div>
                    </div>

                    <Button style={{margin:'auto', borderRadius: '10px', width: '300px', backgroundColor: '#5ea0d4'}} onClick={() => setOpenDialogSignaPoints(true)}>
                        <div className='sig_SignModal_PaperLine sig_Account_Header_Points'>
                            <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline">{t("sProfile.signamedpoints")}</div>
                            <div className="sig_SignModal_PaperBody"> { totalSignaPoints } </div>
                        </div>
                    </Button>
                    <SignaPointsDialog openDialog={openDialogSignaPoints} setOpenDialog={setOpenDialogSignaPoints} setTotalSignaPoints={setTotalSignaPoints} type={'TEAM'} target={team_id_selected}/>
                    <br/>

                    {/* { isAdmin ? <> */}
                        <Button disabled={infoTeam['closed']} className="sig_Teams_ButtonDeleteGroup" style={{margin:'auto', backgroundColor: 'red', height: '30px', width: '50%', color: 'white'}} onClick={() => setIsConfirmDialogOpen(true)} variant="contained">
                            { infoTeam['closed'] ? "CLOSED" : (isAdmin ? t("sTeams.delete_team").toUpperCase() : t("sTeams.cancel_team").toUpperCase()) }
                        </Button>
                        <ConfirmationDialog
                            open={isComfirmDialogOpen}
                            onClose={() => setIsConfirmDialogOpen(false)}
                            onConfirm={remove_Team}
                            message={t("strButton.confirmAction")}
                        />  
                        {/* </>: <></>
                    } */}

                </div>
            </Paper>
            <Paper data-tour="tourSign_3" square className="sig_SignModal_TabsPaper sig_Teams_GroupInfoSection">
                <Tabs
                    className="sig_SignModal_Tabs"
                    value={tabValue}
                    onChange={(event, newValue) => {
                        // console.log('CHANGE TAB: ', newValue)
                        setTabValue(newValue);
                    }}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                <Tab className="sig_SignModal_Tab" label={t("sTeams.tab_description").toUpperCase()} />
                <Tab className="sig_SignModal_Tab" label={t("sTeams.tab_classroom").toUpperCase()} />
                {isAdmin && <Tab className="sig_SignModal_Tab" label={t(`${queryMatches.inDesktopWidth ? 'sTeams.tab_team_activity' : 'sTeams.tab_team_activity_short'}`).toUpperCase()} />}
                {isAdmin && <Tab className="sig_SignModal_Tab" label={t(`${queryMatches.inDesktopWidth ? 'sTeams.tab_setting_invitations' : 'sTeams.tab_setting_invitations_short'}`).toUpperCase()} />}
                </Tabs>
            </Paper>

            {tabValue === pTeamHomeTab.info ? (
                <DialogInfoTeam infoTeam={infoTeam} isAdmin={isAdmin} update_InfoTeam={update_InfoTeam}/>
            ): (<></>)}

            {tabValue === pTeamHomeTab.aula ? (
                <TaskTeams infoTeam={infoTeam} task_id_selected={task_id_selected} setTask_id_selected={setTask_id_selected} refresh_InfoTeam={refresh_InfoTeam} isAdmin={isAdmin}/>
            ): (<></>)}

            {tabValue === pTeamHomeTab.activity ? (
                <DialogTeamActivity infoTeam={infoTeam}/>
            ): (<></>)}

            {tabValue === pTeamHomeTab.invitation ? (
                <DialogInvitationSection infoTeam={infoTeam} setInfoTeam={setInfoTeam}/>
            ): (<></>)}
             
        </>
    );
}